import colors from '../colors';
import * as React from 'react';
import styled from 'styled-components';
import Message from './Message';

interface Props {
    buttons: string[];
    onChange: (val: any) => void;
}
interface State {}

class ChoiceSelect extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(e: React.ChangeEvent<HTMLSelectElement>) {
        this.props.onChange(e.target.value);
    }

    render() {
        const { buttons } = this.props;

        return (
            <Wrapper onChange={this.handleChange}>
                <option>Please choose one</option>
                {buttons.map(item => <option key={item}>{item}</option>)}
            </Wrapper>
        );
    }
}

export default ChoiceSelect;

const Wrapper = styled.select`
    margin-right: 0.5em;
    margin-top: 0.5em;
    margin-bottom: 0;
    background-color: white;
    border-radius: 1em;
    border: 1px solid ${colors.green};
    color: ${colors.green};
    cursor: pointer;
    transition: all 0.1s ease-in;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-transform: none;
    height: 2.5em;
    width: 100%;
    line-height: 1.4;
    font-weight: 400;
    letter-spacing: 0;

    &:focus {
        outline: none;
        border: 1px solid ${colors.green};
    }
`;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/Shared/ChoiceSelect.tsx